import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Mail, ArrowLeft, Send } from 'lucide-react';
import axios from 'axios';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Link reset password telah dikirim ke email Anda');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Terjadi kesalahan');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#0A0A0A] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white dark:bg-zinc-900 rounded-xl border border-slate-200 dark:border-zinc-800 p-8">
          <Link to="/login" className="inline-flex items-center text-sm text-slate-500 hover:text-slate-700 dark:text-zinc-400 dark:hover:text-slate-200 mb-6" data-testid="back-to-login">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Kembali ke Login
          </Link>

          <h1 className="text-2xl font-semibold tracking-tight text-slate-900 dark:text-zinc-50 mb-2" style={{ fontFamily: 'Manrope' }}>
            Lupa Password
          </h1>
          <p className="text-slate-600 dark:text-zinc-400 mb-6 text-sm">
            Masukkan email akun Anda dan kami akan mengirim link untuk reset password.
          </p>

          {sent ? (
            <div className="text-center space-y-4" data-testid="forgot-password-success">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto">
                <Send className="w-8 h-8 text-green-600 dark:text-green-400" />
              </div>
              <h2 className="text-base sm:text-lg font-semibold text-slate-900 dark:text-zinc-50">Email Terkirim!</h2>
              <p className="text-sm text-slate-600 dark:text-zinc-400">
                Cek inbox email <strong>{email}</strong> untuk link reset password. Link berlaku selama 1 jam.
              </p>
              <Button variant="outline" onClick={() => setSent(false)} className="mt-4">
                Kirim Ulang
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <Label htmlFor="email" className="text-slate-700 dark:text-zinc-300 mb-2 block">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500 dark:text-zinc-400" />
                  <Input
                    id="email"
                    type="email"
                    placeholder="nama@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-10 py-6 rounded-xl dark:bg-zinc-800 dark:text-zinc-50 dark:border-zinc-700"
                    required
                    data-testid="forgot-email-input"
                  />
                </div>
              </div>
              <Button
                type="submit"
                className="w-full bg-indigo-600 hover:bg-indigo-700 rounded-xl py-6"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                ) : 'Kirim Link Reset'}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
